import moment from 'moment';
import { LOG_LEVEL } from '../../enums/log-level.enum';

export class LogEntry {
    public id?: number;
    public timestamp: number;
    public level: LOG_LEVEL;
    public message: string;

    public toString(): string {
        const formatPatternDateTimeLog = 'YYYY-MM-DD HH:mm:ss.SSS A';
        return `${moment(this.timestamp).format(formatPatternDateTimeLog)} (${this.level}): ${this.message}`;
    }
}
